module.exports = __webpack_public_path__ + "static/img/role.fc98fe1.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/xk/role.png
// module id = Y4MW
// module chunks = 7